module.exports = __webpack_public_path__ + "img/feat-engage-your-customers.fc1b8505.svg";